var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"app-floating-label",class:[
		_vm.$style['app-floating-label'],
		_vm.$style['app-floating-label--dense'],
		{
			[_vm.$style['app-floating-label--float-above']]: _vm.isFloated,
			[_vm.$style['app-floating-label--focused']]: _vm.isFocused,
			[_vm.$style['app-floating-label--spaced-left']]: _vm.withLeftSpacing
		}
	]},[_c('span',[_vm._v(_vm._s(_vm.labelText))]),(_vm.required)?_c('span',{class:_vm.$style['app-floating-label__required']},[_vm._v("*")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }